import { useNavigate } from "react-router-dom";
import { useUserProvider } from "../../../providers/useUserProvider";
import { useEffect } from "react";

const Logout: React.FC = () => {
    const { clearUser } = useUserProvider();
    const navigate = useNavigate();

    const handleLogout = () => {
        sessionStorage.removeItem("token");
        clearUser();
        navigate("/login");
    }

    useEffect(() => {
        handleLogout();
    });

    return null;
}

export default Logout;